import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useImperativeHandle,
  forwardRef,
  useMemo,
} from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Button,
  TextField,
  Chip,
  Divider,
  Fab,
  FilledInput,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  Typography,
  AppBar,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Menu,
  MenuItem,
  List,
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  ListItem,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import DownloadIcon from "@mui/icons-material/Download";
import IosShareIcon from "@mui/icons-material/IosShare";
import CommentIcon from "@mui/icons-material/Comment";
import ShareIcon from "@mui/icons-material/Share";
import moment from "moment";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import { toast } from "react-toastify";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { makeStyles, styled } from "@mui/styles";
import ViewPDFEdit from "../order-list/ViewPDFEdit";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ViewPDF from "../order-list/ViewPDF";
import { set } from "lodash";
import Draggable from "react-draggable";
import CustomAccordion from "../../utilities/CustomAccordion";
import { useTheme } from "@mui/material/styles";
import {
  useDialogProps,
  useIsMobile,
  accordionSummarySx,
  AbSummary,
  AbMeta,
  CommentThread,
  AnnotationPanel,
  GridToolbar,
  ActionGroup,
  AmendmentGridBox,
  FooterActions,
} from "./AmendmentUIHelpers";

const options = ["Send ", "Send  with Comment"];

export const Modal = ({ src, alt, onClose }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const dialogProps = useDialogProps(PaperComponent);
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(src, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        });

        const contentType = response.headers.get("Content-Type");

        if (contentType && contentType.startsWith("image/")) {
          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          setImageSrc(objectUrl);
          setError(null);
        } else {
          setError(
            "Only image files can be viewed here. Please download the file.",
          );
        }
      } catch (error) {
        console.error("Error fetching image:", error);
        setError("An error occurred while fetching the image.");
      }
    };

    if (src) {
      fetchImage();
    }

    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [src, imageSrc]);

  return (
    <div className="modal">
      <span className="close" onClick={onClose}>
        &times;
      </span>
      {error ? (
        <p
          style={{
            color: theme.palette.error.main,
            fontWeight: "bold",
            fontSize: "24px",
            textAlign: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "80%",
            textOverflow: "ellipsis",
            wordWrap: "break-word",
          }}
        >
          {error}
        </p>
      ) : imageSrc ? (
        <img className="modal-content" src={imageSrc} alt={alt} />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};
function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}
const AmendmentDetails = (props) => {
  const {
    hasPartnersRole,
    index,
    amendmentIndex,
    orderData,
    hasPORSOPRole,
    files,
    token,
    hasPartnerRole,
    editAmendmentFileData,
    hasCustomerRole,
    columnTypes,
    ColorButton,
    setAmendmentUpdateStatus,
    getAmmendment,
    allUserList,
  } = props;
  const [expanded, setExpanded] = useState("panel1");
  const [abFileUrl, setAbFileUrl] = useState("");
  const [openPDF, setOpenPDF] = useState(false);
  const [openSharePDF, setShareOpenPDF] = useState(false);
  const [additionalRevision, setAdditionalRevision] = useState(
    props?.additionalRevision,
  );
  const [amendmentSelectedRow, setAmendmentSelectedRow] = useState([]);
  const [amendmentFileData, setAmendmentFileData] = useState(
    props?.amendmentFileData,
  );
  const [listOfRevisions, setListOfRevisions] = useState(
    props?.listOfRevisions,
  );
  const gridRef = useRef();
  const hiddenPictureFile = useRef(null);
  const params = useParams();
  const theme = useTheme();
  const isMobile = useIsMobile();
  const uploadAmendmentFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadAmendment}`;
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const [isOpen, setIsOpen] = useState(false);
  const [pictureSrc, setPictureSrc] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [shareAbFile, setShareAbFile] = useState();
  const [shareAbFileSop, setShareAbFileSop] = useState();
  const [openComment, setOpenComment] = useState(false);
  const [valueCommentSop, SetValueCommentSop] = useState("");
  const [submitDisableCommentSop, setSubmitDisableCommentSop] = useState(true);
  const [orderExpanded, setOrderExpanded] = useState("panel1");

  const handleCommentChangeSop = (event) => {
    SetValueCommentSop(event.target.value);
  };

  useEffect(() => {
    if (valueCommentSop) {
      setSubmitDisableCommentSop(false);
    } else {
      setSubmitDisableCommentSop(true);
    }
  }, [valueCommentSop]);
  const handleCloseConfirmation = () => {
    setAnchorEl(null);
  };
  const handleCommentPopupClose = () => {
    setOpenComment(false);
    SetValueCommentSop("");
  };
  const handleCommentClose = () => {
    setCommentOpen(false);
    setComment("");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [commentOpen, setCommentOpen] = React.useState(false);
  const [comment, setComment] = React.useState("");
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [toEmail, setToEmail] = useState([]);
  const [ccEmail, setCcEmail] = useState([]);
  const [toEmailInput, setToEmailInput] = useState("");
  const [ccEmailInput, setCcEmailInput] = useState("");
  const [toEmailError, setToEmailError] = useState("");
  const [ccEmailError, setCcEmailError] = useState("");
  const [valueComment, SetValueComment] = useState("");
  const [valueCommentPartner, SetValueCommentPartner] = useState("");
  const [submitDisableComment, setSubmitDisableComment] = useState(true);
  const [amendmentBtnVisible, setAmendmentBtnVisible] = useState(false);
  const [selectedKeyword, setSelectedKeyword] = useState(null);

  const handleCommentChange = (event) => {
    SetValueComment(event.target.value);
  };
  const handleCommentChangePartner = (event) => {
    SetValueCommentPartner(event.target.value);
  };
  useEffect(() => {
    if (valueComment) {
      setSubmitDisableComment(false);
    } else {
      setSubmitDisableComment(true);
    }
  }, [valueComment]);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleMenuItemClick = (index) => {
  //   setSelectedIndex(index);
  //   setAnchorEl(null);

  //   if (index === 1) {
  //     setCommentOpen(true);
  //   } else {
  //     handleABConfirmationSendToNfze(index);
  //   }
  // };
  const handleMenuItemClick = (index, keyword) => {
    setAnchorEl(null);
    if (index === 0) {
      // Direct API call
      handleSendConfirmation(index, keyword);
    } else if (index === 1) {
      // Open comment popup
      setCommentOpen(true);
      setSelectedKeyword(keyword);
    }
  };
  const handleSendConfirmation = (index, keyword) => {
    if (keyword === "nfze") {
      handleABConfirmationSendToNfze(index);
    } else if (keyword === "factory") {
      handleABConfirmationSendToFactory(index);
    }
  };
  const handleSendWithComment = () => {
    if (selectedKeyword) {
      handleSendConfirmation(index, selectedKeyword);
    }
    setCommentOpen(false);
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handlePDFClose = () => {
    setOpenPDF(false);
    setAbFileUrl("");
  };
  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setOrderExpanded(newExpanded ? panel : false);
  };

  const handleSharePDFClose = () => {
    setShareOpenPDF(false);
  };
  const showModal = (src) => {
    setPictureSrc(src.currentTarget.attributes.src.nodeValue);
    setIsOpen(true);
  };
  const handleDownloadABFile = async (e, currentFile) => {
    e.preventDefault();
    e.stopPropagation();
    setAbFileUrl(currentFile);
    if (!currentFile) return;

    const fileId = Array.isArray(currentFile)
      ? currentFile[0]?.id
      : currentFile.id;
    const abNumber = Array.isArray(currentFile)
      ? currentFile[0]?.abNumber
      : currentFile.abNumber;

    try {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
      const response = await OAuthService.getPostPdf(
        hasPartnersRole
          ? `${url}api/downloadCustomerAbFile/${fileId}`
          : `${url}api/downloadAbFile/${fileId}`,
      );

      const blob = new Blob([response?.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const screenWidth = window.screen.availWidth;
      const screenHeight = window.screen.availHeight;
      window.resizeTo(screenWidth / 2, screenHeight);
      window.moveTo(0, 0);

      const pdfWindow = window.open(
        blobUrl,
        "_blank",
        `width=${screenWidth / 2},height=${screenHeight},left=${
          screenWidth / 2
        },top=0,resizable=yes,scrollbars=yes`,
      );

      if (!pdfWindow) {
        alert("Popup blocked. Please allow popups for this site.");
      }
    } catch (error) {
      console.error("Error loading PDF:", error);
      toast.error("Unable to load AB file");
    }
  };

  const handleSendAB = async () => {
    try {
      const formData = new FormData();
      formData.append("abFileId", shareAbFile?.id);
      formData.append("to", toEmail.join(","));
      formData.append("cc", ccEmail.join(","));
      formData.append("comment", valueCommentPartner);
      try {
        const response = await OAuthService.addData(
          url + `api/shareAbWithPartnerTeam`,
          formData,
        );
        toast.success("AB file send successfully");
        setOpenModal(false);
      } catch (error) {
        toast.error(error?.response?.data?.errorMessage || error.message);
        setOpenModal(false);
      }
    } catch (error) {
      toast.error(
        "Error while sharing the AB:",
        error?.response?.data?.errorMessage || error.message,
      );
      setOpenModal(false);
    }
  };

  const handleDownload = async (e, currentFile) => {
    const file = await OAuthService.getPostPdf(
      hasPartnersRole
        ? url + `api/downloadCustomerAbFile/${currentFile?.id}`
        : url + `api/downloadAbFile/${currentFile?.id}`,
    );

    const blob = new Blob([file?.data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${currentFile?.abNumber}`;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  const handleDownloadCustomerAbFileView = async (e, currentFile) => {
    const file = await OAuthService.getPostPdf(
      url + `api/downloadCustomerAbFile/${currentFile?.id}`,
    );

    const blob = new Blob([file?.data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${currentFile?.abNumber}`;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  const handleShareAbCustomer = async (e, currentFile) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      let blob;
      try {
        const file = await OAuthService.getPostPdf(
          `${url}api/downloadAbFile/${currentFile?.id}`,
        );
        blob = new Blob([file?.data], { type: "application/pdf" });
      } catch (error) {
        console.error("Error fetching AB file:", error);
        toast.error("Failed to download AB file.");
        return;
      }

      // Creating a File object from the blob
      const abFile = new File([blob], `${currentFile?.abNumber}.pdf`, {
        type: "application/pdf",
      });

      // Prepare FormData for sending
      const formData = new FormData();
      formData.append("abPdf", abFile);

      try {
        await OAuthService.addFiles(
          `${url}api/sendAbNotification?abFileId=${currentFile?.id}&orderId=${orderData?.id}`,
          formData,
        );

        toast.success("AB file send to customer successfully");
        getAmmendment();
      } catch (error) {
        toast.error(error?.response?.data?.errorMessage || error.message);

        console.error("Error saving the PDF:", error);
      }
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  const handleComment = (e, file) => {
    e.preventDefault();
    e.stopPropagation();
    setShareAbFileSop(file);
    setOpenComment(true);
  };
  const handleSendToCustomerComment = async (comment) => {
    try {
      let blob;
      try {
        const file = await OAuthService.getPostPdf(
          `${url}api/downloadAbFile/${shareAbFileSop?.id}`,
        );
        blob = new Blob([file?.data], { type: "application/pdf" });
      } catch (error) {
        console.error("Error fetching AB file:", error);
        toast.error("Failed to download AB file.");
        return;
      }

      const formData = new FormData();
      formData.append("abPdf", blob, `${shareAbFileSop?.abNumber}.pdf`);

      if (valueCommentSop?.trim()) {
        formData.append("comment", valueCommentSop);
      }

      await OAuthService.addFiles(
        `${url}api/sendAbNotification?abFileId=${shareAbFileSop?.id}&orderId=${orderData?.id}`,
        formData,
      );

      toast.success("AB file send to customer successfully");
      handleCommentPopupClose();
      getAmmendment();
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
      console.error("Error uploading the PDF:", error);
      handleCommentPopupClose();
    }
  };
  const handleDownloadCustomerABFile = async (e, currentFile) => {
    e.preventDefault();
    e.stopPropagation();
    setAbFileUrl(currentFile);
    if (!currentFile) return;

    const fileId = Array.isArray(currentFile)
      ? currentFile[0]?.id
      : currentFile.id;
    const abNumber = Array.isArray(currentFile)
      ? currentFile[0]?.abNumber
      : currentFile.abNumber;

    try {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
      const response = await OAuthService.getPostPdf(
        `${url}api/downloadCustomerAbFile/${fileId}`,
      );

      const blob = new Blob([response?.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const screenWidth = window.screen.availWidth;
      const screenHeight = window.screen.availHeight;
      window.resizeTo(screenWidth / 2, screenHeight);
      window.moveTo(0, 0);

      const pdfWindow = window.open(
        blobUrl,
        "_blank",
        `width=${screenWidth / 2},height=${screenHeight},left=${
          screenWidth / 2
        },top=0,resizable=yes,scrollbars=yes`,
      );

      if (!pdfWindow) {
        alert("Popup blocked. Please allow popups for this site.");
      }
    } catch (error) {
      console.error("Error loading PDF:", error);
      toast.error("Unable to load AB file");
    }
  };
  const handleShareAB = (e, file) => {
    setShareAbFile(file);
    setOpenModal(true);
  };

  const handlePopupClose = () => {
    setOpenModal(false);
  };
  const handleToEmailChange = (e) => {
    setToEmailInput(e.target.value);
  };

  const handleCcEmailChange = (e) => {
    setCcEmailInput(e.target.value);
  };

  const handleAddToEmail = (e) => {
    if (e.key === "Enter" && toEmailInput.trim() !== "") {
      const emails = toEmailInput
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email);
      const invalidEmails = emails.filter((email) => !emailRegex.test(email));

      if (invalidEmails.length > 0) {
        setToEmailError("One or more emails are invalid");
      } else {
        setToEmailError("");
        setToEmail((prevToEmails) => [...prevToEmails, ...emails]);
        setToEmailInput("");
      }
    }
  };

  const handleAddCcEmail = (e) => {
    if (e.key === "Enter" && ccEmailInput.trim() !== "") {
      const emails = ccEmailInput
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email);
      const invalidEmails = emails.filter((email) => !emailRegex.test(email));

      if (invalidEmails.length > 0) {
        setCcEmailError("One or more emails are invalid");
      } else {
        setCcEmailError("");
        setCcEmail((prevCcEmails) => [...prevCcEmails, ...emails]);
        setCcEmailInput("");
      }
    }
  };

  const handleRemoveToEmail = (emailToRemove) => {
    setToEmail((prevEmails) =>
      prevEmails.filter((email) => email !== emailToRemove),
    );
  };

  const handleRemoveCcEmail = (emailToRemove) => {
    setCcEmail((prevEmails) =>
      prevEmails.filter((email) => email !== emailToRemove),
    );
  };
  // const showPictureActionBtn = (props) => {
  //   const fileInputRef = useRef(null);

  //   const handlePictDownload = async () => {
  //     try {
  //       const downloadUrl = url + "api/downloadAmenmentFile";

  //       const response = await axios.post(downloadUrl, null, {
  //         params: {
  //           abFileId: amendmentFileData[index]?.id,
  //           index: props?.node?.rowIndex,
  //         },
  //         headers: {
  //           Authorization: "Bearer " + localStorage.getItem("access_token"),
  //         },
  //         responseType: "blob",
  //       });

  //       const blobUrl = window.URL.createObjectURL(response.data);
  //       const fileName = `${props?.data?.documentPath}`;

  //       const link = document.createElement("a");
  //       link.href = blobUrl;
  //       link.download = fileName;

  //       document.body.appendChild(link);
  //       link.click();
  //       link.parentNode.removeChild(link);

  //       window.URL.revokeObjectURL(blobUrl);
  //     } catch (error) {
  //       toast.error(error.message);
  //     }
  //   };

  //   const handleFileUpload = async (e) => {
  //     const fileUploaded = e.target.files[0];
  //     if (!fileUploaded) return;

  //     if (fileUploaded.size > 15000000) {
  //       toast.error("Please select a file less than 15MB.");
  //       return;
  //     }

  //     const formData = new FormData();
  //     formData.append("file", fileUploaded);

  //     try {
  //       const response = await OAuthService.uploadFile(
  //         uploadAmendmentFileUrl +
  //           `?abNumber=${amendmentFileData[index]?.abNumber}&index=${props?.node?.rowIndex}&abFileId=${amendmentFileData[index]?.id}`,
  //         formData
  //       );

  //       props.node.setDataValue("documentPath", response.data.fileName);
  //       toast.success("File uploaded successfully");
  //     } catch (error) {
  //       toast.error(
  //         error?.response?.data?.errorMessage ||
  //           error?.errorMessage ||
  //           error.message
  //       );
  //     }
  //   };

  //   return (
  //     <Box
  //       sx={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         height: "100%",
  //         gap: 1,
  //       }}
  //     >
  //       {props?.data?.documentPath ? (
  //         <>
  //           <Button size="small" onClick={handlePictDownload}>
  //             <FuseSvgIcon size={18}>material-solid:download</FuseSvgIcon>
  //           </Button>
  //           <Button
  //             size="small"
  //             onClick={showModal}
  //             src={`${url}api/downloadAmenmentFile?abFileId=${amendmentFileData[index]?.id}&index=${props?.node?.rowIndex}`}
  //           >
  //             <FuseSvgIcon size={18} color="action">
  //               heroicons-outline:eye
  //             </FuseSvgIcon>
  //           </Button>
  //         </>
  //       ) : (
  //         <>
  //           <Button
  //             size="small"
  //             onClick={() => fileInputRef.current?.click()}
  //             sx={{
  //               backgroundColor: "transparent",
  //               boxShadow: "none",
  //               textTransform: "none",
  //               padding: "4px 8px",
  //               fontSize: "0.75rem",
  //               minHeight: "32px",
  //               "&:hover": {
  //                 backgroundColor: "rgba(0,0,0,0.04)",
  //               },
  //             }}
  //           >
  //             <FuseSvgIcon size={18}>heroicons-outline:upload</FuseSvgIcon>
  //           </Button>
  //           <input
  //             type="file"
  //             hidden
  //             ref={fileInputRef}
  //             onChange={handleFileUpload}
  //           />
  //         </>
  //       )}
  //     </Box>
  //   );
  // };

  const showPictureActionBtn = (props) => {
    const fileInputRef = useRef(null);

    const handlePictDownload = async () => {
      try {
        const downloadUrl = url + "api/downloadAmenmentFile";

        const response = await axios.post(downloadUrl, null, {
          params: {
            abFileId: amendmentFileData[index]?.id,
            index: props?.node?.rowIndex,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          responseType: "blob",
        });

        const blobUrl = window.URL.createObjectURL(response.data);
        const fileName = `${props?.data?.documentPath}`;

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        toast.error(error.message);
      }
    };

    const handleFileUpload = async (e) => {
      const fileUploaded = e.target.files[0];
      if (!fileUploaded) return;

      if (fileUploaded.size > 15000000) {
        toast.error("Please select a file less than 15MB.");
        return;
      }

      const formData = new FormData();
      formData.append("file", fileUploaded);

      try {
        const response = await OAuthService.uploadFile(
          uploadAmendmentFileUrl +
            `?abNumber=${amendmentFileData[index]?.abNumber}&index=${props?.node?.rowIndex}&abFileId=${amendmentFileData[index]?.id}`,
          formData,
        );

        const updatedRow = {
          ...props.data,
          documentPath: response.data.fileName,
          localFileUrl: URL.createObjectURL(fileUploaded),
        };

        props.node.setData(updatedRow);

        const updated = [...amendmentFileData];

        updated[index].listAdditionalRevisions[props.node.rowIndex] =
          updatedRow;

        setAmendmentFileData(updated);
        toast.success("File uploaded successfully");
      } catch (error) {
        toast.error(
          error?.response?.data?.errorMessage ||
            error?.errorMessage ||
            error.message,
        );
      }
    };
    const isReadOnly =
      (hasPartnersRole &&
        (files?.amendmentStatus === "AMENDMENT_REQUEST_NFZE" ||
          files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY" ||
          orderData?.orderStatus === "UNDER_CONFIRMATION")) ||
      (hasPORSOPRole &&
        (files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY" ||
          files?.amendmentStatus === "AMENDMENT_REQUEST_NFZE"));
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          gap: 1,
          minWidth: 0,
        }}
      >
        {props?.data?.documentPath ? (
          props?.data?.localFileUrl ? (
            <>
              <Chip
                label={props?.data?.documentPath}
                title={props?.data?.documentPath}
                size="small"
                sx={{
                  maxWidth: 160,
                  minWidth: 0,

                  "& .MuiChip-label": {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },

                  "& .MuiChip-deleteIcon": {
                    flexShrink: 0,
                  },
                }}
                onDelete={() => {
                  const updatedRow = {
                    ...props.data,
                    documentPath: "",
                    localFileUrl: "",
                  };

                  props.node.setData(updatedRow);

                  const updated = [...amendmentFileData];

                  updated[index].listAdditionalRevisions[props.node.rowIndex] =
                    updatedRow;

                  setAmendmentFileData(updated);

                  if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                  }

                  toast.warn("File removed");
                }}
              />

              <Button
                size="small"
                onClick={() => {
                  window.open(props?.data?.localFileUrl, "_blank");
                }}
              >
                <FuseSvgIcon
                  size={18}
                  sx={{ color: theme.palette.secondary.main }}
                >
                  heroicons-outline:eye
                </FuseSvgIcon>
              </Button>

              <Button
                size="small"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = props?.data?.localFileUrl;
                  link.download = props?.data?.documentPath;

                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              >
                <FuseSvgIcon
                  size={18}
                  sx={{ color: theme.palette.secondary.main }}
                >
                  material-solid:download
                </FuseSvgIcon>
              </Button>
            </>
          ) : isReadOnly ? (
            <>
              <Chip
                label={props?.data?.documentPath}
                title={props?.data?.documentPath}
                size="small"
                sx={{
                  maxWidth: 160,
                  minWidth: 0,

                  "& .MuiChip-label": {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },

                  "& .MuiChip-deleteIcon": {
                    flexShrink: 0,
                  },
                }}
              />

              <Button size="small" onClick={handlePictDownload}>
                <FuseSvgIcon
                  size={18}
                  sx={{ color: theme.palette.secondary.main }}
                >
                  material-solid:download
                </FuseSvgIcon>
              </Button>

              <Button
                size="small"
                onClick={showModal}
                src={`${url}api/downloadAmenmentFile?abFileId=${amendmentFileData[index]?.id}&index=${props?.node?.rowIndex}`}
              >
                <FuseSvgIcon
                  size={18}
                  sx={{ color: theme.palette.secondary.main }}
                >
                  heroicons-outline:eye
                </FuseSvgIcon>
              </Button>
            </>
          ) : (
            <Chip
              label={props?.data?.documentPath}
              title={props?.data?.documentPath}
              size="small"
              sx={{
                maxWidth: 160,
                minWidth: 0,

                "& .MuiChip-label": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },

                "& .MuiChip-deleteIcon": {
                  flexShrink: 0,
                },
              }}
              onDelete={() => {
                const updatedRow = {
                  ...props.data,
                  documentPath: "",
                };

                props.node.setData(updatedRow);

                const updated = [...amendmentFileData];

                updated[index].listAdditionalRevisions[props.node.rowIndex] =
                  updatedRow;

                setAmendmentFileData(updated);

                if (fileInputRef.current) {
                  fileInputRef.current.value = "";
                }

                toast.warn("File removed");
              }}
            />
          )
        ) : (
          <>
            <Button
              size="small"
              onClick={() => fileInputRef.current?.click()}
              sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                textTransform: "none",
                padding: "4px 8px",
                fontSize: "0.75rem",
                minHeight: "32px",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              <FuseSvgIcon size={18}>heroicons-outline:upload</FuseSvgIcon>
            </Button>

            <input
              type="file"
              hidden
              ref={fileInputRef}
              onChange={handleFileUpload}
            />
          </>
        )}
      </Box>
    );
  };
  const errorCellRenderer = (params) => {
    if (params.data?.errorMessage) {
      return (
        <div style={{ position: "relative", display: "inline-block" }}>
          <span>{params.value || ""}</span>
          <div
            style={{
              position: "absolute",
              left: "100%",
              top: "50%",
              transform: "translateY(-50%)",
              background: theme.palette.error.main,
              color: theme.palette.error.contrastText,
              padding: "4px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              whiteSpace: "nowrap",
              zIndex: 10,
            }}
          >
            {params.data.errorMessage}
          </div>
        </div>
      );
    }
    return params.value || "";
  };

  const [columnAmendmentDefs, setColumnAmendmentDefs] = useState([
    {
      field: "posNo",
      headerName: "Pos. No",
      minWidth: 45,
      width: 45,
    },
    {
      field: "articleCode",
      headerName: "Article Code",
      minWidth: 150,
      valueFormatter: (params) =>
        params.value ? params.value.toUpperCase() : "",
      valueSetter: (params) => {
        if (params.newValue) {
          params.data.articleCode = params.newValue.toUpperCase();
          return true;
        }
        return false;
      },
    },
    {
      field: "amendment",
      headerName: "Amendment*",
      minWidth: 300,
      valueParser: (params) => {
        const value = params.newValue?.trim();

        if (!value) {
          alert("Invalid input: Amendment is required.");
          return params.oldValue ?? "";
        }

        return value;
      },
    },
    {
      field: "documentFile",
      hide: true,
    },
    {
      field: "documentPath",
      headerName: "Document Upload",
      editable: false,
      cellRenderer: (props) => showPictureActionBtn(props),
      minWidth: 200,
      cellEditorParams: {
        amendmentFileData: amendmentFileData,
        amendmentIndex: amendmentIndex,
      },
    },
    {
      field: "remarks",
      headerName: "Remarks",
      minWidth: 150,
    },
  ]);
  const areAllAmendmentsFilled = (rows) => {
    return (
      rows?.length > 0 &&
      rows.every((row) => row.amendment && row.amendment.trim() !== "")
    );
  };
  const editAmendmentRow = useCallback(() => {
    const index =
      listOfRevisions &&
      listOfRevisions?.findIndex(
        (row) =>
          JSON.stringify(amendmentSelectedRow[0]) === JSON.stringify(row),
      );
    setTimeout(() => {
      gridRef.current.api.setFocusedCell(index, "posNo");
      gridRef.current.api.startEditingCell({
        rowIndex: index,
        colKey: "posNo",
      });
    }, 800);
  }, [listOfRevisions, amendmentSelectedRow]);
  const handleAnnotationEdit = (data, index) => {
    const updated = [...amendmentFileData];

    updated[index].questionAndAnnotation = data;
    setAmendmentFileData(updated);
  };

  const handleAnnotationComment = (data, index) => {
    const updated = [...amendmentFileData];

    updated[index].replyToQuestions = data;
    setAmendmentFileData(updated);
  };
  const deletePartRowAmendment = useCallback(() => {
    const selectedRow = gridRef.current.api.getSelectedRows();
    gridRef?.current?.api.applyTransaction({ remove: selectedRow });

    const updated = [...amendmentFileData];

    const updatedRevisions = [...updated[index].listAdditionalRevisions];

    selectedRow.forEach((row) => {
      const rowIndex = updatedRevisions.findIndex((r) => r === row);
      if (rowIndex !== -1) {
        updatedRevisions.splice(rowIndex, 1);
      }
    });

    updated[index].listAdditionalRevisions = updatedRevisions;
    setAmendmentFileData(updated);

    gridRef.current.api.refreshCells();
  }, [amendmentFileData, index]);

  const onBtAdd = useCallback(
    (index) => {
      let newRow = {
        posNo: "",
        articleCode: "",
        amendment: "",
        documentPath: "",
        remarks: "",
      };
      const updated = [...amendmentFileData];
      if (updated[index].listAdditionalRevisions) {
        updated[index].listAdditionalRevisions = [
          ...updated[index].listAdditionalRevisions,
          newRow,
        ];
      } else {
        updated[index].listAdditionalRevisions = [newRow];
      }
      setAmendmentFileData(updated);
      if (amendmentBtnVisible) {
        setAmendmentBtnVisible(false);
      }
    },
    [amendmentFileData, amendmentBtnVisible],
  );
  const handleSendToNfze = async (amendIndex) => {
    if (amendmentFileData.length > 0) {
      try {
        const singleAmendment = amendmentFileData[amendIndex];

        // if (singleAmendment.listAdditionalRevisions) {
        //   singleAmendment.listAdditionalRevisions.map((list) => {
        //     if (list.documentFile) {
        //       const payload = {
        //         file: [list.documentFile],
        //         customerId: orderData?.customerNum,
        //         commissionName: orderData?.commissionName,
        //         isOriginal: true,
        //       };
        //       OAuthService.addFiles(`${uploadOrderFileUrl}`, payload).then(
        //         (files) => {
        //           const data = files.data;
        //           const fileId = data.map((file) => file.id);
        //         }
        //       );
        //     }
        //     delete list.documentFile;
        //     return list;
        //   });
        // }
        delete singleAmendment.newComments;
        delete singleAmendment?._links;
        if (singleAmendment.listAdditionalRevisions) {
          singleAmendment.listAdditionalRevisions =
            singleAmendment.listAdditionalRevisions.map((list) => {
              const updatedList = { ...list };

              delete updatedList.localFileUrl;
              delete updatedList.documentFile;

              return updatedList;
            });
        }
        const response = await OAuthService.putData(
          url + `api/sendOrderAmendmentToNfze?id=${params?.id}`,
          singleAmendment,
        );
        toast.success("Amendment Send to NFZE successfully.");
        setAmendmentUpdateStatus(true);
      } catch (error) {
        toast.error(error?.response?.data?.errorMessage || error.message);
      }
    }
  };
  const handleABConfirmationSendToNfze = async (index) => {
    try {
      const singleAmendment = amendmentFileData[index];
      singleAmendment.listAdditionalRevisions = files?.listAdditionalRevisions;
      if (singleAmendment.listAdditionalRevisions) {
        singleAmendment.listAdditionalRevisions =
          singleAmendment.listAdditionalRevisions.map((list) => {
            const updatedList = { ...list };

            delete updatedList.localFileUrl;
            delete updatedList.documentFile;

            return updatedList;
          });
      }
      const params = new URLSearchParams();

      if (files?.replyToQuestions) {
        params.append("reply", files.replyToQuestions);
      }

      if (comment) {
        params.append("comment", comment);
      }

      await OAuthService.updateData(
        `${url}/api/sendAbConfirmationToNfze/${
          singleAmendment?.id
        }?${params.toString()}`,
      );

      // if (comment) {
      //   await OAuthService.updateData(
      //     url +
      //       `/api/sendAbConfirmationToNfze/${singleAmendment?.id}?reply=${files?.replyToQuestions}&comment=${comment}&`
      //   );
      // } else {
      //   await OAuthService.updateData(
      //     url + `/api/sendAbConfirmationToNfze/${singleAmendment?.id}?reply=${files?.replyToQuestions}`
      //   );
      // }
      toast.success("AB Confirmation Send to NFZE successfully.");
      setAmendmentUpdateStatus(true);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const handleSendToFactory = async (amendIndex) => {
    if (amendmentFileData.length > 0) {
      try {
        const singleAmendment = amendmentFileData[amendIndex];

        singleAmendment.listAdditionalRevisions =
          files?.listAdditionalRevisions;
        delete singleAmendment.newComments;
        delete singleAmendment?._links;
        if (singleAmendment.listAdditionalRevisions) {
          singleAmendment.listAdditionalRevisions =
            singleAmendment.listAdditionalRevisions.map((list) => {
              const updatedList = { ...list };

              delete updatedList.localFileUrl;
              delete updatedList.documentFile;

              return updatedList;
            });
        }
        await OAuthService.putData(
          url + `api/sendOrderAmendmentToFactory?id=${params?.id}`,
          singleAmendment,
        );
        toast.success("Amendment Send to Factory successfully.");
        setAmendmentUpdateStatus(true);
      } catch (error) {
        toast.error(error?.response?.data?.errorMessage || error.message);
      }
    }
  };
  const handleABConfirmationSendToFactory = async (index) => {
    try {
      const singleAmendment = amendmentFileData[index];
      singleAmendment.listAdditionalRevisions = files?.listAdditionalRevisions;
      if (singleAmendment.listAdditionalRevisions) {
        singleAmendment.listAdditionalRevisions =
          singleAmendment.listAdditionalRevisions.map((list) => {
            const updatedList = { ...list };

            delete updatedList.localFileUrl;
            delete updatedList.documentFile;

            return updatedList;
          });
      }
      const formData = new FormData();

      formData.append("questionAndAnnotation", files?.questionAndAnnotation);
      formData.append("replyToQuestions", files?.replyToQuestions || "");
      formData.append("id", singleAmendment?.id);
      if (comment) {
        formData.append("comment", comment);
      }
      await OAuthService.addData(
        url + "api/sendConfirmOrderToFactory",
        formData,
      );
      toast.success("AB Confirmation Send to Factory successfully.");
      setAmendmentUpdateStatus(true);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const onSelectionAmendmentChanged = (params) => {
    setAmendmentSelectedRow(params.api.getSelectedRows());
  };

  const onCellValueChanged = (params) => {
    const { data, colDef, node } = params;

    if (colDef.field === "amendment") {
      if (!data.amendment || data.amendment.trim() === "") {
        alert("Amendment is required.");
        data.amendment = "";
        setAmendmentBtnVisible(false);
      } else {
        setAmendmentBtnVisible(true);
      }
    }

    gridRef.current.api.refreshCells({ rowNodes: [node], force: true });
  };

  const handleAdditionalRevision = (e, index) => {
    const revisions = [...additionalRevision];
    revisions[index] = true;
    setAdditionalRevision(revisions);
  };

  const onGridReadyAmendment = (params) => {};

  return (
    <div>
      {hasPartnersRole ? (
        files.sharedAbFileName ? (
          <Accordion
            expanded={expanded === `panel${index + 1}`}
            onChange={handleChange(`panel${index + 1}`)}
            sx={{ marginTop: "16px" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="items-center"
              sx={accordionSummarySx}
            >
              <AbSummary index={index}>
                {/* delete the numbered <Box> that was here: AbSummary draws it */}
                <Button
                  variant="text"
                  size="small"
                  startIcon={<PictureAsPdfRoundedIcon />}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleDownloadABFile(e, files);
                  }}
                >
                  View #AB {orderData?.abNumber}
                </Button>
                <Button
                  variant="text"
                  size="small"
                  startIcon={<DownloadIcon />}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleDownload(e, files);
                  }}
                >
                  Download
                </Button>
                <Button
                  variant="text"
                  size="small"
                  startIcon={<ShareIcon />}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleShareAB(e, files);
                  }}
                >
                  Share AB
                </Button>
                <Dialog
                  fullWidth={true}
                  maxWidth={"md"}
                  onClose={handlePopupClose}
                  open={openModal}
                  PaperComponent={PaperComponent}
                  aria-labelledby="draggable-dialog-title"
                >
                  <AppBar
                    position="static"
                    color="secondary"
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                  >
                    <Toolbar className="flex w-full justify-between">
                      <Typography variant="subtitle1" color="inherit">
                        Send the AB file
                      </Typography>
                      <IconButton onClick={handlePopupClose} color="inherit">
                        <Icon>close</Icon>
                      </IconButton>
                    </Toolbar>
                  </AppBar>

                  <DialogTitle>
                    <TextField
                      label="To Email"
                      name="toEmail"
                      type="text"
                      fullWidth
                      variant="outlined"
                      value={toEmailInput}
                      onChange={handleToEmailChange}
                      onKeyDown={handleAddToEmail}
                      error={!!toEmailError}
                      helperText={toEmailError || "Press Enter to add email"}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          padding: "10px",
                        },
                      }}
                    />
                    <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
                      {toEmail.map((email, index) => (
                        <Chip
                          key={index}
                          label={email}
                          onDelete={() => handleRemoveToEmail(email)}
                          color="secondary"
                        />
                      ))}
                    </Box>
                  </DialogTitle>

                  <DialogTitle>
                    <TextField
                      label="CC Email"
                      name="ccEmail"
                      type="text"
                      fullWidth
                      variant="outlined"
                      value={ccEmailInput}
                      onChange={handleCcEmailChange}
                      onKeyDown={handleAddCcEmail}
                      error={!!ccEmailError}
                      helperText={ccEmailError || "Press Enter to add email"}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          padding: "10px",
                        },
                      }}
                    />
                    <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
                      {ccEmail.map((email, index) => (
                        <Chip
                          key={index}
                          label={email}
                          onDelete={() => handleRemoveCcEmail(email)}
                          color="secondary"
                        />
                      ))}
                    </Box>
                  </DialogTitle>
                  <DialogTitle>
                    <Box sx={{ mb: 2 }}>
                      <TextField
                        id="outlined-textarea"
                        label="Comment"
                        placeholder="Write your comment here"
                        multiline
                        fullWidth
                        rows={5}
                        value={valueCommentPartner}
                        onChange={handleCommentChangePartner}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            padding: "10px",
                          },
                        }}
                      />
                    </Box>
                  </DialogTitle>

                  <DialogActions>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleSendAB}
                      disabled={toEmail.length === 0 || toEmailError}
                    >
                      Send AB
                    </Button>
                  </DialogActions>
                </Dialog>

                <AbMeta
                  label="AB Received Date"
                  value={
                    files?.createdDate &&
                    `${moment(files.createdDate).format(
                      "DD-MM-YYYY - HH:mm",
                    )} GST`
                  }
                />

                {/* non-partner branch: the "Customer Shared" / "Share" / "Add Comment" buttons unchanged,
      and replace the "AB Shared Date" <span> with: */}
                <AbMeta
                  label="AB Shared Date"
                  value={
                    files?.abShareDate &&
                    `${moment(files.abShareDate).format(
                      "DD-MM-YYYY - HH:mm",
                    )} GST`
                  }
                />
              </AbSummary>
            </AccordionSummary>
            {files?.comments.length > 0 && (
              <CustomAccordion
                panel="panel1"
                expanded={orderExpanded}
                onChange={handleAccordionChange}
                header="AB Comments"
              >
                <CommentThread
                  comments={files?.comments}
                  token={token}
                  allUserList={allUserList}
                />
              </CustomAccordion>
            )}

            <AccordionDetails>
              <Grid container spacing={{ xs: 2, md: 3 }}>
                <Grid item xs={12} md={6}>
                  <AnnotationPanel
                    title="Annotation in AB"
                    date={
                      files?.processedTime &&
                      moment(files.processedTime).format("DD-MM-YYYY")
                    }
                  >
                    <TextField
                      placeholder="Write your Annotation Question"
                      multiline
                      value={files?.questionAndAnnotation}
                      onChange={(e) =>
                        handleAnnotationEdit(e.target.value, index)
                      }
                      fullWidth
                      disabled={
                        hasPartnersRole
                          ? true
                          : orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? false
                          : true
                      }
                      rows={isMobile ? 6 : 12}
                    />
                  </AnnotationPanel>
                </Grid>

                <Grid item xs={12} md={6}>
                  <AnnotationPanel title="Reply to Annotations">
                    <TextField
                      placeholder="Write your comment here"
                      multiline
                      value={files?.replyToQuestions || ""}
                      onChange={(e) =>
                        handleAnnotationComment(e.target.value, index)
                      }
                      fullWidth
                      disabled={
                        hasPORSOPRole &&
                        orderData.orderStatus === "UNDER_CONFIRMATION" &&
                        files?.questionAndAnnotation
                          ? false
                          : hasPartnersRole
                          ? !files?.questionAndAnnotation // Disable if hasPartnersRole is true and questionAndAnnotation is empty
                          : orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? false
                          : true
                      }
                      rows={isMobile ? 6 : 12}
                    />
                  </AnnotationPanel>
                </Grid>
              </Grid>

              {listOfRevisions[index] !== null ||
              files?.amendmentStatus === "AMENDMENT_REQUEST_NFZE" ||
              files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY" ? (
                <Box sx={{ mt: 2 }}>
                  {(orderData.orderStatus === "AB_RECEIVED" ||
                    orderData.orderStatus === "UNDER_CONFIRMATION") && (
                    <GridToolbar>
                      <IconButton
                        disabled={
                          (hasPartnersRole &&
                            (files?.amendmentStatus ===
                              "AMENDMENT_REQUEST_NFZE" ||
                              files?.amendmentStatus ===
                                "AMENDMENT_REQUEST_FACTORY")) ||
                          (hasPORSOPRole &&
                            files?.amendmentStatus ===
                              "AMENDMENT_REQUEST_FACTORY")
                            ? true
                            : orderData.orderStatus === "AB_RECEIVED" ||
                              orderData.orderStatus === "UNDER_CONFIRMATION"
                            ? false
                            : true
                        }
                        onClick={() => onBtAdd(index)}
                      >
                        <FuseSvgIcon
                          size={24}
                          sx={{ color: theme.palette.secondary.main }}
                        >
                          heroicons-outline:plus-circle
                        </FuseSvgIcon>
                      </IconButton>
                      {token?.scope?.includes("ROLE_PARTNER_ADMIN") &&
                        orderData.orderStatus === "AB_RECEIVED" &&
                        (files?.amendmentStatus !==
                          "AMENDMENT_REQUEST_FACTORY" ||
                          files?.amendmentStatus !==
                            "AMENDMENT_REQUEST_NFZE") && (
                          <ActionGroup>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto" }}
                              disabled={
                                amendmentSelectedRow.length === 0 ||
                                files?.amendmentStatus ===
                                  "AMENDMENT_REQUEST_FACTORY" ||
                                files?.amendmentStatus ===
                                  "AMENDMENT_REQUEST_NFZE"
                              }
                              onClick={deletePartRowAmendment}
                            >
                              <FuseSvgIcon
                                size={18}
                                sx={{ color: theme.palette.secondary.main }}
                              >
                                material-solid:delete
                              </FuseSvgIcon>
                            </Button>
                          </ActionGroup>
                        )}
                      {(token?.scope?.includes("ROLE_SOPDIR") ||
                        token?.scope?.includes("ROLE_ORDERPRO") ||
                        token?.scope?.includes("ROLE_MD") ||
                        token?.scope?.includes("ROLE_ADMIN")) &&
                        (orderData.orderStatus === "AB_RECEIVED" ||
                          orderData.orderStatus === "UNDER_CONFIRMATION") && (
                          <ActionGroup>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto" }}
                              disabled={
                                amendmentSelectedRow.length === 0 ||
                                files?.amendmentStatus ===
                                  "AMENDMENT_REQUEST_FACTORY"
                              }
                              onClick={editAmendmentRow}
                            >
                              <FuseSvgIcon
                                size={18}
                                sx={{ color: theme.palette.secondary.main }}
                              >
                                material-solid:edit
                              </FuseSvgIcon>
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto" }}
                              disabled={
                                amendmentSelectedRow.length === 0 ||
                                files?.amendmentStatus ===
                                  "AMENDMENT_REQUEST_FACTORY"
                              }
                              onClick={deletePartRowAmendment}
                            >
                              <FuseSvgIcon
                                size={18}
                                sx={{ color: theme.palette.secondary.main }}
                              >
                                material-solid:delete
                              </FuseSvgIcon>
                            </Button>
                          </ActionGroup>
                        )}
                    </GridToolbar>
                  )}
                  <AmendmentGridBox>
                    <AgGridTable
                      columnDefs={columnAmendmentDefs}
                      onGridReady={onGridReadyAmendment}
                      gridRef={gridRef}
                      rowData={files?.listAdditionalRevisions || []}
                      rowGroupPanelShow={"never"}
                      hideCheckbox={true}
                      pagination={false}
                      rowHeight={30}
                      columnTypes={columnTypes}
                      onSelectionChanged={onSelectionAmendmentChanged}
                      onCellValueChanged={onCellValueChanged}
                    />
                  </AmendmentGridBox>
                </Box>
              ) : (
                additionalRevision[index] && (
                  <Box sx={{ mt: 2 }}>
                    {(orderData.orderStatus === "AB_RECEIVED" ||
                      orderData.orderStatus === "UNDER_CONFIRMATION") && (
                      <GridToolbar>
                        <IconButton
                          disabled={
                            orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                              ? false
                              : true
                          }
                          onClick={() => onBtAdd(index)}
                        >
                          <FuseSvgIcon
                            size={24}
                            sx={{ color: theme.palette.secondary.main }}
                          >
                            heroicons-outline:plus-circle
                          </FuseSvgIcon>
                        </IconButton>
                        {token?.scope?.includes("ROLE_PARTNER_ADMIN") &&
                          orderData.orderStatus === "AB_RECEIVED" &&
                          (files?.amendmentStatus !==
                            "AMENDMENT_REQUEST_FACTORY" ||
                            files?.amendmentStatus !==
                              "AMENDMENT_REQUEST_NFZE") && (
                            <ActionGroup>
                              <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                sx={{ minWidth: "auto" }}
                                disabled={
                                  amendmentSelectedRow.length === 0 ||
                                  files?.amendmentStatus ===
                                    "AMENDMENT_REQUEST_FACTORY" ||
                                  files?.amendmentStatus ===
                                    "AMENDMENT_REQUEST_NFZE"
                                }
                                onClick={deletePartRowAmendment}
                              >
                                <FuseSvgIcon
                                  size={18}
                                  sx={{ color: theme.palette.secondary.main }}
                                >
                                  material-solid:delete
                                </FuseSvgIcon>
                              </Button>
                            </ActionGroup>
                          )}
                        {(token?.scope?.includes("ROLE_SOPDIR") ||
                          token?.scope?.includes("ROLE_ORDERPRO") ||
                          token?.scope?.includes("ROLE_MD") ||
                          token?.scope?.includes("ROLE_ADMIN")) &&
                          (orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION") && (
                            <ActionGroup>
                              <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                sx={{ minWidth: "auto" }}
                                disabled={
                                  amendmentSelectedRow.length === 0 ||
                                  files?.amendmentStatus ===
                                    "AMENDMENT_REQUEST_FACTORY"
                                }
                                onClick={editAmendmentRow}
                              >
                                <FuseSvgIcon
                                  size={18}
                                  sx={{ color: theme.palette.secondary.main }}
                                >
                                  material-solid:edit
                                </FuseSvgIcon>
                              </Button>
                              <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                sx={{ minWidth: "auto" }}
                                disabled={
                                  amendmentSelectedRow.length === 0 ||
                                  files?.amendmentStatus ===
                                    "AMENDMENT_REQUEST_FACTORY"
                                }
                                onClick={deletePartRowAmendment}
                              >
                                <FuseSvgIcon
                                  size={18}
                                  sx={{ color: theme.palette.secondary.main }}
                                >
                                  material-solid:delete
                                </FuseSvgIcon>
                              </Button>
                            </ActionGroup>
                          )}
                      </GridToolbar>
                    )}
                    <AmendmentGridBox>
                      <AgGridTable
                        columnDefs={columnAmendmentDefs}
                        onGridReady={onGridReadyAmendment}
                        gridRef={gridRef}
                        rowData={files?.listAdditionalRevisions || []}
                        rowGroupPanelShow={"never"}
                        hideCheckbox={true}
                        pagination={false}
                        rowHeight={30}
                        columnTypes={columnTypes}
                        onSelectionChanged={onSelectionAmendmentChanged}
                        //  onCellEditingStopped={onCellEditStop}
                        onCellValueChanged={onCellValueChanged}
                      />
                    </AmendmentGridBox>
                  </Box>
                )
              )}
              
              <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between mt-16">
                {!amendmentFileData[index]?.listAdditionalRevisions && (
                  <div>
                    <Button
                      onClick={(e) => handleAdditionalRevision(e, index)}
                      variant="contained"
                      color="secondary"
                      size="small"
                      disabled={
                        orderData.orderStatus === "AB_RECEIVED" ||
                        orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? (hasPartnersRole &&
                              (files.amendmentStatus ===
                                "AMENDMENT_REQUEST_NFZE" ||
                                files.amendmentStatus ===
                                  "AMENDMENT_REQUEST_FACTORY" ||
                                orderData.orderStatus ===
                                  "UNDER_CONFIRMATION")) ||
                            (hasPORSOPRole &&
                              files.amendmentStatus ===
                                "AMENDMENT_REQUEST_FACTORY")
                            ? true
                            : false
                          : true
                      }
                    >
                      Additional Revisions
                    </Button>
                  </div>
                )}

                <div className="flex flex-col w-full sm:w-auto sm:flex-row flex-1 items-center justify-end">
                  {!hasPORSOPRole &&
                    (token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
                      token?.scope?.includes("ROLE_SHWRMMGR") ||
                      token?.scope?.includes("ROLE_PARTNRDESIGN") ||
                      token?.scope?.includes("ROLE_PARTNRORDPROCESS") ||
                      token?.scope?.includes("ROLE_PARTNER")) && (
                      <Button
                        variant="contained"
                        color="secondary"
                        className="mr-8"
                        size="small"
                        disabled={
                          (files?.listAdditionalRevisions
                            ? !areAllAmendmentsFilled(
                                files?.listAdditionalRevisions,
                              )
                            : false) ||
                          (files?.amendmentStatus ===
                            "AMENDMENT_REQUEST_NFZE" ||
                          files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY"
                            ? true
                            : orderData.orderStatus === "AB_RECEIVED" ||
                              orderData.orderStatus === "UNDER_CONFIRMATION"
                            ? files?.questionAndAnnotation
                              ? files?.replyToQuestions
                                ? false
                                : true
                              : files?.listAdditionalRevisions &&
                                amendmentBtnVisible &&
                                JSON.stringify(
                                  files?.listAdditionalRevisions,
                                ) !==
                                  JSON.stringify(
                                    editAmendmentFileData[index]
                                      ?.listAdditionalRevisions,
                                  )
                              ? false
                              : true
                            : true)
                        }
                        onClick={() => handleSendToNfze(index)}
                      >
                        Send Amendment to NFZE
                      </Button>
                    )}
                  {(token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
                    token?.scope?.includes("ROLE_SHWRMMGR") ||
                    token?.scope?.includes("ROLE_PARTNRDESIGN") ||
                    token?.scope?.includes("ROLE_PARTNRORDPROCESS") ||
                    token?.scope?.includes("ROLE_PARTNER")) && (
                    <div>
                      <Button
                        variant="contained"
                        className="bg-[#09D404] text-white hover:bg-[#09D404] focus:bg-[#09D404] active:bg-[#09D404]"
                        size="small"
                        onClick={handleClick}
                        disabled={
                          orderData?.orderStatus === "AB_RECEIVED" &&
                          files?.listAdditionalRevisions === null &&
                          files?.questionAndAnnotation &&
                          files?.replyToQuestions
                            ? false
                            : files?.amendmentStatus ===
                                "AMENDMENT_REQUEST_NFZE" ||
                              files?.amendmentStatus ===
                                "AMENDMENT_REQUEST_FACTORY" ||
                              orderData.orderStatus === "UNDER_CONFIRMATION"
                            ? true
                            : orderData.orderStatus === "AB_RECEIVED" ||
                              orderData.orderStatus === "UNDER_CONFIRMATION"
                            ? additionalRevision[index] &&
                              files?.listAdditionalRevisions?.length > 0
                              ? true
                              : !files?.questionAndAnnotation
                              ? false
                              : !files?.replyToQuestions
                              ? true
                              : files?.replyToQuestions?.trim()?.length > 0
                              ? false
                              : additionalRevision[index] ||
                                (editAmendmentFileData[index]
                                  ?.listAdditionalRevisions &&
                                  editAmendmentFileData[index]
                                    ?.listAdditionalRevisions.length > 0)
                              ? false
                              : true
                            : true
                        }
                      >
                        Confirmation to NFZE
                      </Button>
                      <Menu
                        id="confirmation-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCloseConfirmation}
                        MenuListProps={{
                          "aria-labelledby": "confirmation-button",
                          role: "listbox",
                        }}
                      >
                        {options.map((option, index) => (
                          <MenuItem
                            key={option}
                            onClick={() => handleMenuItemClick(index, "nfze")}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Menu>

                      {/* Comment Popup */}
                      <Dialog
                        open={commentOpen}
                        onClose={handleCommentClose}
                        fullWidth
                        maxWidth="md"
                        PaperComponent={PaperComponent}
                        aria-labelledby="draggable-dialog-title"
                      >
                        <DialogTitle>Add a Comment</DialogTitle>
                        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                          <DialogContentText id="alert-dialog-description">
                            Please enter a comment before sending the
                            confirmation.
                          </DialogContentText>
                        </DialogContent>
                        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                          <Box sx={{ mb: 2 }}>
                            <TextField
                              id="outlined-textarea"
                              label="Comment"
                              placeholder="Write your comment here"
                              multiline
                              fullWidth
                              rows={5}
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                            />
                          </Box>
                        </DialogContent>

                        <DialogActions>
                          <Button
                            variant="outlined"
                            color="secondary"
                            autoFocus
                            onClick={handleCommentClose}
                          >
                            Cancel
                          </Button>

                          <Button
                            variant="contained"
                            color="secondary"
                            autoFocus
                            onClick={handleSendWithComment}
                            disabled={!comment}
                          >
                            Send
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                  )}

                  {!hasPartnerRole &&
                    (token?.scope?.includes("ROLE_SOPDIR") ||
                      token?.scope?.includes("ROLE_ORDERPRO") ||
                      token?.scope?.includes("ROLE_MD") ||
                      token?.scope?.includes("ROLE_ADMIN")) && (
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        sx={{ ml: 1 }}
                        disabled={
                          (files?.listAdditionalRevisions
                            ? !areAllAmendmentsFilled(
                                files?.listAdditionalRevisions,
                              )
                            : false) ||
                          (files?.amendmentStatus ===
                          "AMENDMENT_REQUEST_FACTORY"
                            ? true
                            : orderData.orderStatus === "AB_RECEIVED" ||
                              orderData.orderStatus === "UNDER_CONFIRMATION"
                            ? files?.questionAndAnnotation ||
                              amendmentFileData[
                                index
                              ]?.questionAndAnnotation?.trim()
                              ? files?.replyToQuestions ||
                                amendmentFileData[
                                  index
                                ]?.replyToQuestions?.trim()
                                ? false
                                : true
                              : files?.listAdditionalRevisions ||
                                JSON.stringify(
                                  files?.listAdditionalRevisions,
                                ) !==
                                  JSON.stringify(
                                    editAmendmentFileData[index]
                                      ?.listAdditionalRevisions,
                                  )
                              ? false
                              : true
                            : true)
                        }
                        onClick={() => handleSendToFactory(index)}
                      >
                        Send Amendment to Factory
                      </Button>
                    )}
                  {(token?.scope?.includes("ROLE_SOPDIR") ||
                    token?.scope?.includes("ROLE_ORDERPRO") ||
                    token?.scope?.includes("ROLE_MD") ||
                    token?.scope?.includes("ROLE_ADMIN")) && (
                    <>
                      <Button
                        variant="contained"
                        // color="secondary"
                        className="bg-[#09D404] text-white hover:bg-[#09D404] focus:bg-[#09D404] active:bg-[#09D404]"
                        size="small"
                        sx={{ ml: 1 }}
                        onClick={handleClick}
                        disabled={
                          files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY"
                            ? true
                            : orderData.orderStatus === "AB_RECEIVED" ||
                              orderData.orderStatus === "UNDER_CONFIRMATION"
                            ? additionalRevision[index]
                              ? true
                              : !editAmendmentFileData[index]
                                  ?.questionAndAnnotation ||
                                !editAmendmentFileData[index]?.replyToQuestions
                              ? false
                              : editAmendmentFileData[index]
                                  ?.questionAndAnnotation &&
                                editAmendmentFileData[index]?.replyToQuestions
                              ? false
                              : additionalRevision[index] ||
                                (editAmendmentFileData[index]
                                  ?.listAdditionalRevisions &&
                                  editAmendmentFileData[index]
                                    ?.listAdditionalRevisions.length > 0)
                              ? false
                              : true
                            : true
                        }
                      >
                        Confirmation to Factory
                      </Button>
                      <Menu
                        id="confirmation-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCloseConfirmation}
                        MenuListProps={{
                          "aria-labelledby": "confirmation-button",
                          role: "listbox",
                        }}
                      >
                        {options.map((option, index) => (
                          <MenuItem
                            key={option}
                            onClick={() =>
                              handleMenuItemClick(index, "factory")
                            }
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Menu>
                      <Dialog
                        open={commentOpen}
                        onClose={handleCommentClose}
                        fullWidth
                        maxWidth="md"
                        PaperComponent={PaperComponent}
                        aria-labelledby="draggable-dialog-title"
                      >
                        <DialogTitle>Add a Comment</DialogTitle>
                        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                          <DialogContentText id="alert-dialog-description">
                            Please enter a comment before sending the
                            confirmation.
                          </DialogContentText>
                        </DialogContent>
                        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                          <Box sx={{ mb: 2 }}>
                            <TextField
                              id="outlined-textarea"
                              label="Comment"
                              placeholder="Write your comment here"
                              multiline
                              fullWidth
                              rows={5}
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                            />
                          </Box>
                        </DialogContent>

                        <DialogActions>
                          <Button
                            variant="outlined"
                            color="secondary"
                            autoFocus
                            onClick={handleCommentClose}
                          >
                            Cancel
                          </Button>

                          <Button
                            variant="contained"
                            color="secondary"
                            autoFocus
                            onClick={handleSendWithComment}
                            disabled={!comment}
                          >
                            Send
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </>
                  )}
                </div>
              </div>
            </AccordionDetails>
            <ViewPDFEdit
              open={openPDF}
              abFiles={abFileUrl}
              handleClose={handlePDFClose}
              title={`View AB - ${orderData?.abNumber}`}
              orderStatus={orderData?.orderStatus}
              partnerStatus={hasPartnersRole}
              orderId={orderData?.id}
              customerStatus={hasCustomerRole}
              // setSuccessMsg={setSuccessMsg}
            />
          </Accordion>
        ) : (
          <></>
        )
      ) : (
        <Accordion
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
          sx={{ marginTop: "16px" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="items-center"
            sx={accordionSummarySx}
          >
            <AbSummary index={index}>
              <Button
                variant="text"
                size="small"
                startIcon={<PictureAsPdfRoundedIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDownloadABFile(e, files);
                }}
              >
                View #AB {orderData?.abNumber}
              </Button>
              <Button
                variant="text"
                size="small"
                startIcon={<DownloadIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDownload(e, files);
                }}
              >
                Download
              </Button>

              <AbMeta
                label="AB Received Date"
                value={
                  files?.createdDate &&
                  `${moment(files.createdDate).format(
                    "DD-MM-YYYY - HH:mm",
                  )} GST`
                }
              />
              {files.sharedAbFileName && files?.abShareDate ? (
                <>
                  <Button
                    variant="text"
                    size="small"
                    startIcon={<PictureAsPdfRoundedIcon />}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDownloadCustomerABFile(e, files);
                    }}
                  >
                    Customer Shared #AB {orderData?.abNumber}
                  </Button>
                  <Button
                    variant="text"
                    size="small"
                    startIcon={<DownloadIcon />}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDownloadCustomerAbFileView(e, files);
                    }}
                  >
                    Download
                  </Button>
                  <AbMeta
                    label="AB Shared Date"
                    value={
                      files?.abShareDate &&
                      `${moment(files.abShareDate).format(
                        "DD-MM-YYYY - HH:mm",
                      )} GST`
                    }
                  />
                </>
              ) : (
                <>
                  <Button
                    variant="text"
                    size="small"
                    startIcon={<IosShareIcon />}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleShareAbCustomer(e, files);
                    }}
                  >
                    Share #AB {orderData?.abNumber}
                  </Button>
                  <Button
                    variant="text"
                    size="small"
                    startIcon={<CommentIcon />}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleComment(e, files);
                    }}
                  >
                    Add Comment
                  </Button>
                </>
              )}
            </AbSummary>
          </AccordionSummary>

          {files?.comments.length > 0 && (
            <CustomAccordion
              panel="panel1"
              expanded={orderExpanded}
              onChange={handleAccordionChange}
              header="AB Comments"
            >
              <CommentThread
                comments={files?.comments}
                token={token}
                allUserList={allUserList}
              />
            </CustomAccordion>
          )}

          <AccordionDetails>
            <Grid container spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={12} md={6}>
                <AnnotationPanel
                  title="Annotation in AB"
                  date={
                    files?.processedTime &&
                    moment(files.processedTime).format("DD-MM-YYYY")
                  }
                >
                  <TextField
                    placeholder="Write your Annotation Question"
                    multiline
                    value={files?.questionAndAnnotation}
                    onChange={(e) =>
                      handleAnnotationEdit(e.target.value, index)
                    }
                    fullWidth
                    disabled={
                      hasPartnersRole
                        ? true
                        : orderData.orderStatus === "AB_RECEIVED" ||
                          orderData.orderStatus === "UNDER_CONFIRMATION"
                        ? false
                        : true
                    }
                    rows={isMobile ? 6 : 12}
                  />{" "}
                  {/* keep all your other props */}
                </AnnotationPanel>
              </Grid>

              <Grid item xs={12} md={6}>
                <AnnotationPanel title="Reply to Annotations">
                  <TextField
                    placeholder="Write your comment here"
                    multiline
                    value={files?.replyToQuestions || ""}
                    onChange={(e) =>
                      handleAnnotationComment(e.target.value, index)
                    }
                    fullWidth
                    disabled={
                      hasPORSOPRole &&
                      orderData.orderStatus === "UNDER_CONFIRMATION" &&
                      files?.questionAndAnnotation
                        ? false
                        : hasPartnersRole
                        ? !files?.questionAndAnnotation // Disable if hasPartnersRole is true and questionAndAnnotation is empty
                        : orderData.orderStatus === "AB_RECEIVED" ||
                          orderData.orderStatus === "UNDER_CONFIRMATION"
                        ? false
                        : true
                    }
                    rows={isMobile ? 6 : 12}
                  />
                </AnnotationPanel>
              </Grid>
            </Grid>

            {listOfRevisions[index] !== null ||
            files?.amendmentStatus === "AMENDMENT_REQUEST_NFZE" ||
            files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY" ? (
              <Box sx={{ mt: 2 }}>
                {(orderData.orderStatus === "AB_RECEIVED" ||
                  orderData.orderStatus === "UNDER_CONFIRMATION") && (
                  <GridToolbar>
                    <IconButton
                      disabled={
                        (hasPartnersRole &&
                          (files?.amendmentStatus ===
                            "AMENDMENT_REQUEST_NFZE" ||
                            files?.amendmentStatus ===
                              "AMENDMENT_REQUEST_FACTORY")) ||
                        (hasPORSOPRole &&
                          files?.amendmentStatus ===
                            "AMENDMENT_REQUEST_FACTORY")
                          ? true
                          : orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? false
                          : true
                      }
                      onClick={() => onBtAdd(index)}
                    >
                      <FuseSvgIcon
                        size={24}
                        sx={{ color: theme.palette.secondary.main }}
                      >
                        heroicons-outline:plus-circle
                      </FuseSvgIcon>
                    </IconButton>
                    {token?.scope?.includes("ROLE_PARTNER_ADMIN") &&
                      orderData.orderStatus === "AB_RECEIVED" &&
                      (files?.amendmentStatus !== "AMENDMENT_REQUEST_FACTORY" ||
                        files?.amendmentStatus !==
                          "AMENDMENT_REQUEST_NFZE") && (
                        <ActionGroup>
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            sx={{ minWidth: "auto" }}
                            disabled={
                              amendmentSelectedRow.length === 0 ||
                              files?.amendmentStatus ===
                                "AMENDMENT_REQUEST_FACTORY" ||
                              files?.amendmentStatus ===
                                "AMENDMENT_REQUEST_NFZE"
                            }
                            onClick={deletePartRowAmendment}
                          >
                            <FuseSvgIcon
                              size={18}
                              sx={{ color: theme.palette.secondary.main }}
                            >
                              material-solid:delete
                            </FuseSvgIcon>
                          </Button>
                        </ActionGroup>
                      )}
                    {(token?.scope?.includes("ROLE_SOPDIR") ||
                      token?.scope?.includes("ROLE_ORDERPRO") ||
                      token?.scope?.includes("ROLE_MD") ||
                      token?.scope?.includes("ROLE_ADMIN")) &&
                      (orderData.orderStatus === "AB_RECEIVED" ||
                        orderData.orderStatus === "UNDER_CONFIRMATION") && (
                        <ActionGroup>
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            sx={{ minWidth: "auto" }}
                            disabled={
                              amendmentSelectedRow.length === 0 ||
                              files?.amendmentStatus ===
                                "AMENDMENT_REQUEST_FACTORY"
                            }
                            onClick={editAmendmentRow}
                          >
                            <FuseSvgIcon
                              size={18}
                              sx={{ color: theme.palette.secondary.main }}
                            >
                              material-solid:edit
                            </FuseSvgIcon>
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            sx={{ minWidth: "auto" }}
                            disabled={
                              amendmentSelectedRow.length === 0 ||
                              files?.amendmentStatus ===
                                "AMENDMENT_REQUEST_FACTORY"
                            }
                            onClick={deletePartRowAmendment}
                          >
                            <FuseSvgIcon
                              size={18}
                              sx={{ color: theme.palette.secondary.main }}
                            >
                              material-solid:delete
                            </FuseSvgIcon>
                          </Button>
                        </ActionGroup>
                      )}
                  </GridToolbar>
                )}
                <AmendmentGridBox>
                  <AgGridTable
                    columnDefs={columnAmendmentDefs}
                    onGridReady={onGridReadyAmendment}
                    gridRef={gridRef}
                    rowData={files?.listAdditionalRevisions || []}
                    rowGroupPanelShow={"never"}
                    hideCheckbox={true}
                    pagination={false}
                    rowHeight={30}
                    columnTypes={columnTypes}
                    onSelectionChanged={onSelectionAmendmentChanged}
                    //  onCellEditingStopped={onCellEditStop}
                    onCellValueChanged={onCellValueChanged}
                  />
                </AmendmentGridBox>
              </Box>
            ) : (
              additionalRevision[index] && (
                <Box sx={{ mt: 2 }}>
                  {(orderData.orderStatus === "AB_RECEIVED" ||
                    orderData.orderStatus === "UNDER_CONFIRMATION") && (
                    <GridToolbar>
                      <IconButton
                        disabled={
                          orderData.orderStatus === "AB_RECEIVED" ||
                          orderData.orderStatus === "UNDER_CONFIRMATION"
                            ? false
                            : true
                        }
                        onClick={() => onBtAdd(index)}
                      >
                        <FuseSvgIcon
                          size={24}
                          sx={{ color: theme.palette.secondary.main }}
                        >
                          heroicons-outline:plus-circle
                        </FuseSvgIcon>
                      </IconButton>
                      {token?.scope?.includes("ROLE_PARTNER_ADMIN") &&
                        orderData.orderStatus === "AB_RECEIVED" &&
                        (files?.amendmentStatus !==
                          "AMENDMENT_REQUEST_FACTORY" ||
                          files?.amendmentStatus !==
                            "AMENDMENT_REQUEST_NFZE") && (
                          <ActionGroup>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto" }}
                              disabled={
                                amendmentSelectedRow.length === 0 ||
                                files?.amendmentStatus ===
                                  "AMENDMENT_REQUEST_FACTORY" ||
                                files?.amendmentStatus ===
                                  "AMENDMENT_REQUEST_NFZE"
                              }
                              onClick={deletePartRowAmendment}
                            >
                              <FuseSvgIcon
                                size={18}
                                sx={{ color: theme.palette.secondary.main }}
                              >
                                material-solid:delete
                              </FuseSvgIcon>
                            </Button>
                          </ActionGroup>
                        )}
                      {(token?.scope?.includes("ROLE_SOPDIR") ||
                        token?.scope?.includes("ROLE_ORDERPRO") ||
                        token?.scope?.includes("ROLE_MD") ||
                        token?.scope?.includes("ROLE_ADMIN")) &&
                        (orderData.orderStatus === "AB_RECEIVED" ||
                          orderData.orderStatus === "UNDER_CONFIRMATION") && (
                          <ActionGroup>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto" }}
                              disabled={amendmentSelectedRow.length === 0}
                              onClick={editAmendmentRow}
                            >
                              <FuseSvgIcon
                                size={18}
                                sx={{ color: theme.palette.secondary.main }}
                              >
                                material-solid:edit
                              </FuseSvgIcon>
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              sx={{ minWidth: "auto" }}
                              disabled={amendmentSelectedRow.length === 0}
                              onClick={deletePartRowAmendment}
                            >
                              <FuseSvgIcon
                                size={18}
                                sx={{ color: theme.palette.secondary.main }}
                              >
                                material-solid:delete
                              </FuseSvgIcon>
                            </Button>
                          </ActionGroup>
                        )}
                    </GridToolbar>
                  )}
                  <AmendmentGridBox>
                    <AgGridTable
                      columnDefs={columnAmendmentDefs}
                      onGridReady={onGridReadyAmendment}
                      gridRef={gridRef}
                      rowData={files?.listAdditionalRevisions || []}
                      rowGroupPanelShow={"never"}
                      hideCheckbox={true}
                      columnTypes={columnTypes}
                      pagination={false}
                      rowHeight={30}
                      onSelectionChanged={onSelectionAmendmentChanged}
                      //  onCellEditingStopped={onCellEditStop}
                      onCellValueChanged={onCellValueChanged}
                    />
                  </AmendmentGridBox>
                </Box>
              )
            )}
            <div className="flex flex-col sm:flex-row flex-1 w-full items-center justify-between mt-16">
              {!amendmentFileData[index]?.listAdditionalRevisions && (
                <div>
                  <Button
                    onClick={(e) => handleAdditionalRevision(e, index)}
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={
                      orderData.orderStatus === "AB_RECEIVED" ||
                      orderData.orderStatus === "UNDER_CONFIRMATION"
                        ? (hasPartnersRole &&
                            (files.amendmentStatus ===
                              "AMENDMENT_REQUEST_NFZE" ||
                              files.amendmentStatus ===
                                "AMENDMENT_REQUEST_FACTORY" ||
                              orderData.orderStatus ===
                                "UNDER_CONFIRMATION")) ||
                          (hasPORSOPRole &&
                            files.amendmentStatus ===
                              "AMENDMENT_REQUEST_FACTORY")
                          ? true
                          : false
                        : true
                    }
                  >
                    Additional Revisions
                  </Button>
                </div>
              )}

              <div className="flex flex-col w-full sm:w-auto sm:flex-row flex-1 items-center justify-end">
                {!hasPORSOPRole &&
                  (token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
                    token?.scope?.includes("ROLE_SHWRMMGR") ||
                    token?.scope?.includes("ROLE_PARTNRDESIGN") ||
                    token?.scope?.includes("ROLE_PARTNRORDPROCESS") ||
                    token?.scope?.includes("ROLE_PARTNER")) && (
                    <Button
                      variant="contained"
                      color="secondary"
                      className="mr-8"
                      size="small"
                      disabled={
                        (files?.listAdditionalRevisions
                          ? !areAllAmendmentsFilled(
                              files?.listAdditionalRevisions,
                            )
                          : false) ||
                        (files?.amendmentStatus === "AMENDMENT_REQUEST_NFZE" ||
                        files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY"
                          ? true
                          : orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? files?.questionAndAnnotation
                            ? files?.replyToQuestions
                              ? false
                              : true
                            : files?.listAdditionalRevisions &&
                              amendmentBtnVisible &&
                              JSON.stringify(files?.listAdditionalRevisions) !==
                                JSON.stringify(
                                  editAmendmentFileData[index]
                                    ?.listAdditionalRevisions,
                                )
                            ? false
                            : true
                          : true)
                      }
                      onClick={() => handleSendToNfze(index)}
                    >
                      Send Amendment to NFZE
                    </Button>
                  )}

                {(token?.scope?.includes("ROLE_PARTNER_ADMIN") ||
                  token?.scope?.includes("ROLE_SHWRMMGR") ||
                  token?.scope?.includes("ROLE_PARTNRDESIGN") ||
                  token?.scope?.includes("ROLE_PARTNRORDPROCESS") ||
                  token?.scope?.includes("ROLE_PARTNER")) && (
                  <div>
                    <Button
                      variant="contained"
                      // color="primary"
                      className="bg-[#09D404] text-white hover:bg-[#09D404] focus:bg-[#09D404] active:bg-[#09D404]"
                      size="small"
                      onClick={handleClick}
                      disabled={
                        orderData?.orderStatus === "AB_RECEIVED" &&
                        files?.listAdditionalRevisions.length === null &&
                        files?.questionAndAnnotation &&
                        files?.replyToQuestions
                          ? false
                          : files?.amendmentStatus ===
                              "AMENDMENT_REQUEST_NFZE" ||
                            files?.amendmentStatus ===
                              "AMENDMENT_REQUEST_FACTORY" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? true
                          : orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? additionalRevision[index] &&
                            files?.listAdditionalRevisions?.length > 0
                            ? true
                            : !files?.questionAndAnnotation
                            ? false
                            : !files?.replyToQuestions
                            ? true
                            : files?.replyToQuestions?.trim()?.length > 0
                            ? false
                            : additionalRevision[index] ||
                              (editAmendmentFileData[index]
                                ?.listAdditionalRevisions &&
                                editAmendmentFileData[index]
                                  ?.listAdditionalRevisions.length > 0)
                            ? false
                            : true
                          : true
                      }
                    >
                      Confirmation to NFZE
                    </Button>
                    <Menu
                      id="confirmation-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseConfirmation}
                      MenuListProps={{
                        "aria-labelledby": "confirmation-button",
                        role: "listbox",
                      }}
                    >
                      {options.map((option, index) => (
                        <MenuItem
                          key={option}
                          onClick={() => handleMenuItemClick(index, "nfze")}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>

                    {/* Comment Popup */}
                    <Dialog
                      open={commentOpen}
                      onClose={handleCommentClose}
                      fullWidth
                      maxWidth="md"
                      PaperComponent={PaperComponent}
                      aria-labelledby="draggable-dialog-title"
                    >
                      <DialogTitle>Add a Comment</DialogTitle>
                      <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                        <DialogContentText id="alert-dialog-description">
                          Please enter a comment before sending the
                          confirmation.
                        </DialogContentText>
                      </DialogContent>
                      <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                        <Box sx={{ mb: 2 }}>
                          <TextField
                            id="outlined-textarea"
                            label="Comment"
                            placeholder="Write your comment here"
                            multiline
                            fullWidth
                            rows={5}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                          />
                        </Box>
                      </DialogContent>

                      <DialogActions>
                        <Button
                          variant="contained"
                          color="secondary"
                          autoFocus
                          onClick={handleCommentClose}
                        >
                          Cancel
                        </Button>

                        <Button
                          variant="contained"
                          color="secondary"
                          autoFocus
                          onClick={handleSendWithComment}
                          disabled={!comment}
                        >
                          Send
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                )}

                {!hasPartnerRole &&
                  (token?.scope?.includes("ROLE_SOPDIR") ||
                    token?.scope?.includes("ROLE_ORDERPRO") ||
                    token?.scope?.includes("ROLE_MD") ||
                    token?.scope?.includes("ROLE_ADMIN")) && (
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      sx={{ ml: 1 }}
                      disabled={
                        (files?.listAdditionalRevisions?.length > 0
                          ? !areAllAmendmentsFilled(
                              files?.listAdditionalRevisions,
                            )
                          : false) ||
                        (files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY"
                          ? true
                          : orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? files?.questionAndAnnotation ||
                            amendmentFileData[
                              index
                            ]?.questionAndAnnotation?.trim()
                            ? files?.replyToQuestions ||
                              amendmentFileData[index]?.replyToQuestions?.trim()
                              ? false
                              : true
                            : files?.listAdditionalRevisions ||
                              JSON.stringify(files?.listAdditionalRevisions) !==
                                JSON.stringify(
                                  editAmendmentFileData[index]
                                    ?.listAdditionalRevisions,
                                )
                            ? false
                            : true
                          : true)
                      }
                      onClick={() => handleSendToFactory(index)}
                    >
                      Send Amendment to Factory
                    </Button>
                  )}
                {(token?.scope?.includes("ROLE_SOPDIR") ||
                  token?.scope?.includes("ROLE_ORDERPRO") ||
                  token?.scope?.includes("ROLE_MD") ||
                  token?.scope?.includes("ROLE_ADMIN")) && (
                  <>
                    <Button
                      variant="contained"
                      // color="secondary"
                      className="bg-[#09D404] text-white hover:bg-[#09D404] focus:bg-[#09D404] active:bg-[#09D404]"
                      size="small"
                      sx={{ ml: 1 }}
                      onClick={handleClick}
                      disabled={
                        files?.amendmentStatus === "AMENDMENT_REQUEST_FACTORY"
                          ? true
                          : orderData.orderStatus === "AB_RECEIVED" ||
                            orderData.orderStatus === "UNDER_CONFIRMATION"
                          ? additionalRevision[index]?.listAdditionalRevisions
                              ?.length > 0
                            ? true
                            : !editAmendmentFileData[index]
                                ?.questionAndAnnotation ||
                              !editAmendmentFileData[index]?.replyToQuestions
                            ? false
                            : editAmendmentFileData[index]
                                ?.questionAndAnnotation &&
                              editAmendmentFileData[index]?.replyToQuestions
                            ? false
                            : additionalRevision[index] ||
                              (editAmendmentFileData[index]
                                ?.listAdditionalRevisions &&
                                editAmendmentFileData[index]
                                  ?.listAdditionalRevisions.length > 0)
                            ? false
                            : true
                          : true
                      }
                    >
                      Confirmation to Factory
                    </Button>
                    <Menu
                      id="confirmation-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseConfirmation}
                      MenuListProps={{
                        "aria-labelledby": "confirmation-button",
                        role: "listbox",
                      }}
                    >
                      {options.map((option, index) => (
                        <MenuItem
                          key={option}
                          onClick={() => handleMenuItemClick(index, "factory")}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>
                    <Dialog
                      open={commentOpen}
                      onClose={handleCommentClose}
                      fullWidth
                      maxWidth="md"
                      PaperComponent={PaperComponent}
                      aria-labelledby="draggable-dialog-title"
                    >
                      <DialogTitle>Add a Comment</DialogTitle>
                      <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                        <DialogContentText id="alert-dialog-description">
                          Please enter a comment before sending the
                          confirmation.
                        </DialogContentText>
                      </DialogContent>
                      <DialogContent classes={{ root: "p-16 sm:p-24" }}>
                        <Box sx={{ mb: 2 }}>
                          <TextField
                            id="outlined-textarea"
                            label="Comment"
                            placeholder="Write your comment here"
                            multiline
                            fullWidth
                            rows={5}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                          />
                        </Box>
                      </DialogContent>

                      <DialogActions>
                        <Button
                          variant="outlined"
                          color="secondary"
                          autoFocus
                          onClick={handleCommentClose}
                        >
                          Cancel
                        </Button>

                        <Button
                          variant="contained"
                          color="secondary"
                          autoFocus
                          onClick={handleSendWithComment}
                          disabled={!comment}
                        >
                          Send
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                )}
              </div>
            </div>
          </AccordionDetails>
          <ViewPDFEdit
            open={openPDF}
            abFiles={abFileUrl}
            handleClose={handlePDFClose}
            title={`View AB - ${orderData?.abNumber}`}
            orderStatus={orderData?.orderStatus}
            partnerStatus={hasPartnersRole}
            orderId={orderData?.id}
            customerStatus={hasCustomerRole}
            // setSuccessMsg={setSuccessMsg}
          />
          <ViewPDF
            open={openSharePDF}
            handleClose={handleSharePDFClose}
            abFiles={abFileUrl}
            title={`Customer Shared AB - ${orderData?.abNumber}`}
            flag={true}
          />
        </Accordion>
      )}
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        onClose={handleCommentPopupClose}
        open={openComment}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <AppBar
          position="static"
          color="secondary"
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Add Comment
            </Typography>
            <IconButton onClick={handleCommentPopupClose} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box sx={{ mb: 2 }}>
            <TextField
              id="outlined-textarea"
              label="Comment"
              placeholder="Write your comment here"
              multiline
              fullWidth
              rows={10}
              value={valueCommentSop}
              onChange={handleCommentChangeSop}
            />
          </Box>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            size="large"
            disabled={submitDisableCommentSop}
            onClick={() => handleSendToCustomerComment(valueCommentSop)}
          >
            Send to Customer
          </Button>
        </DialogContent>
      </Dialog>
      {isOpen && (
        <Modal src={pictureSrc} alt="snow" onClose={() => setIsOpen(false)} />
      )}
    </div>
  );
};

export default AmendmentDetails;
